import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** logo_cloud — horizontal partner logo list. */
export function renderLogoCloud(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const logos = list(section.fields, 'logos')
    .map((item, index) => {
      const url = itemStr(item, 'url');
      const itemAlt = itemStr(item, 'alt');
      if (!url) return '';
      let alt = 'Partner';
      if (itemAlt) alt = itemAlt;
      const logoPath = `/logos/${index}`;
      return `    <img class="ve-logo-cloud__logo" src="${safeUrl(url)}" alt="${escapeHtml(alt)}"${editAttr(section, logoPath)}>`;
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'logo-cloud', heading, label),
    itemCollection(section, 'div', 've-logo-cloud__logos', '/logos', logos),
    '</section>',
  ];
  return parts.join('\n');
}
